import { Tag,Edit2, Link, Share2, Trash2 } from "react-feather";
import { DescriptionBookMarkPropsType } from "../../../../Types/BookmarkType";
import { Href } from "../../../../Constants/Constants";
import { H6, LI, P, UL } from "../../../../AbstractElements";

const DescriptionData:React.FC<DescriptionBookMarkPropsType> = ({ data, onHandleClick, removeFromBookmark}) => {
  const { title, website_url, id } = data;
  
  return (
    <div className="desciption-data">
      <div className="title-bookmark">
        <H6 className="title_0">{title}</H6>
        <P className="weburl_0">{website_url}</P>
        <div className="hover-block">
          <UL className="simple-list flex-row">
            <LI><a href={Href} onClick={() => onHandleClick(data)}><Edit2 /></a></LI>
            <LI><a href={Href}><Link /></a></LI>
            <LI><a href={Href}><Share2 /></a></LI>
            <LI><a href={Href} onClick={() => removeFromBookmark(id)}><Trash2 /></a></LI>
            <LI className="text-end"><a href={Href}><Tag /></a></LI>
          </UL>
        </div>
        <div className="content-general">
          <P className="desc_0">{data.desc}</P>
          <span className="collection_0">{data.collection}</span>
        </div>
      </div>
    </div>
  );
};

export default DescriptionData;
